export default __webpack_public_path__ + "static/media/img8.b35bae2a.png";